<template>
  <side-panel-inner on-close="AdminPollsIndex" :headerTitle="headerTitle">
    <template slot="actions" v-if="!loading">
      <base-button
        primary="true"
        @click="handleSubmit"
        v-if="!editMode && userCanAdd"
        type="button"
        >Save</base-button
      >
      <base-button
        primary="true"
        @click="handleSubmit"
        v-if="editMode && userCanAdd"
        type="button"
        >Update</base-button
      >
    </template>
    <loading v-if="loading" />

    <form v-else>
      <form-field
        label="Poll Title"
        helper-text="The title of the poll.  This should be the question"
        required
        v-model="currentPoll.title"
        data-vv-as="title"
        id="title"
        name="title"
        v-validate="{ required: true }"
        full-width
        :error="errors.first('title')"
      />

      <form-field
        label="Poll Description"
        helper-text="Describe the poll.  This should help the user understand the poll."
        v-model="currentPoll.body"
        full-width
        required
        type="textarea"
      />

      <form-field
        label="Category"
        name="category"
        helper-text="Select the category you want the poll to appear in"
        :required="true"
      >
        <form-type-ahead-select
          v-model="currentCategory"
          id="category_id"
          name="category_id"
          :options="orderedCategories"
          async-action="SurveyCategories/quickList"
          display-field="name"
          @input="onCategoryInput"
          v-if="!loading"
        />
        <p v-else>Loading categories</p>
        <p v-if="!!editMode">
          <small
            >Once a poll is published, you can not change its category.</small
          >
        </p>
      </form-field>

      <form-field
        label="Responsible Users"
        name="responsible_users"
        required
        helper-text="Give people responsibility of this form"
      >
        <div class="row">
          <div class="col-xs-12">
            <form-label small required>Primary</form-label>
            <user-select
              v-model="currentPoll.primary_user"
              id="survey_primary_user"
              name="survey_primary_user"
              v-validate="{ required: true }"
              data-vv-as="primary user"
              :error="errors.first('survey_primary_user')"
            ></user-select>
          </div>
          <div class="col-xs-12">
            <form-label small required>Secondary</form-label>
            <user-select
              v-model="currentPoll.secondary_user"
              id="survey_secondary_user"
              name="survey_secondary_user"
              v-validate="{
                required: true,
                is_not: currentPoll.primary_user_id,
              }"
              data-vv-as="secondary user"
              :error="errors.first('survey_secondary_user')"
            ></user-select>
          </div>
        </div>
      </form-field>

      <form-field
        label="Anonymise responses"
        name="anonymous"
        helper-text="Selecting this will prevent users from seeing specific user information in the results"
      >
        <form-toggle v-model="currentPoll.anonymous" />
      </form-field>

      <form-field
        label="Allow multiple responses?"
        name="multiple"
        helper-text="Determine if a user can submit multiple entries, or only submit once"
      >
        <form-toggle v-model="currentPoll.multiple" />
      </form-field>

      <form-field
        label="Private"
        name="private"
        helper-text="Do you want the poll results to be private?"
      >
        <form-toggle v-model="currentPoll.private" />
      </form-field>

      <user-group-select
        @onChange="onUserAdd"
        v-if="currentPoll.private"
        :value="selectedUsers"
      />

      <form-field
        label="Poll Choices"
        helper-text="Set the possible choices for the poll.  Please add at least 2 choices.  You can re-order the choices at any time."
        full-width
      >
        <ol class="listless draggable">
          <draggable v-model="currentPoll.options" handle=".draggable__icon">
            <li
              v-for="(choice, index) in currentPoll.options"
              :key="choice.sortOrder"
            >
              <icon
                name="drag"
                width="27"
                height="27"
                color="black"
                class="draggable__icon"
                v-if="choices.length > 1"
              ></icon>
              <form-field
                :value="choice.name"
                full-width
                v-model="currentPoll.options[index].name"
              />
              <base-button
                inline
                danger
                type="button"
                @click="removeChoice(choice)"
                :aria-labelledby="`close_${choice.sortOrder}`"
                v-if="choices.length > 2"
                ><span
                  class="screen-reader-text"
                  :id="`close_${choice.sortOrder}`"
                  >Remove choice</span
                ><icon name="cross"
              /></base-button>
            </li>
          </draggable>
        </ol>
        <base-button @click="addNewChoice" type="button"
          >Add choice</base-button
        >
      </form-field>
    </form>
  </side-panel-inner>
</template>
<script>
import draggable from "vuedraggable";
import { mapState, mapGetters } from "vuex";
import Pagination from "@/components/pagination";
import { FormToggle, UserGroupSelect } from "@/components/forms";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import UserSelect from "@/components/UserSelect";
import FormTypeAheadSelect from "@/components/FormTypeAheadSelect";
import UserHasPermission from "@/mixins/UserHasPermission";
export default {
  name: "PollsAdminIndex",

  components: {
    Pagination,
    VuetablePagination,
    draggable,
    UserSelect,
    FormToggle,
    FormTypeAheadSelect,
    UserGroupSelect,
  },

  mixins: [UserHasPermission],

  methods: {
    onUserAdd(value) {
      this.selected_users = [];
      this.currentPoll.users = [];
      this.currentPoll.user_ids = [];
      value.forEach((val) => {
        //if we are a group, we need to extract the individual user ids
        if (val.id.toString().includes("grp")) {
          val = val.meta.data;
          this.currentPoll.user_ids = [...this.currentPoll.user_ids, ...val];
        } else {
          this.currentPoll.user_ids.push(val);
          this.currentPoll.users.push(val);
        }
        this.selected_users.push(val);
      });
    },
    updateChoiceText(event, choice) {
      choice.name = event;
    },
    onCategoryInput(val) {
      this.currentPoll.category_id = val.id;
    },
    addNewChoice() {
      const sortOrder = this.currentPoll.options.length;
      this.currentPoll.options.push({ sortOrder, name: null });
    },
    removeChoice(choice) {
      console.log(
        "TCL:  ~ file: AddEdit.vue ~ line 227 ~ removeChoice ~ choice",
        choice
      );
      // return;
      this.currentPoll.options = this.currentPoll.options.filter(
        (option) => option.id !== choice.id
      );
      // .map((option, index) => ({ ...option, sortOrder: index }));
    },
    handleActivate() {
      const status =
        this.currenrPoll.status === "active" ? "inactive" : "active";
      this.$store.dispatch("Polls/setStatus", status);
    },
    handleSubmit() {
      this.loading = true;

      const vm = this;
      this.$validator.validate().then((result) => {
        if (!result) {
          this.loading = false;
          vm.showValidationMessage = true;
        } else {
          const action = vm.editMode ? "update" : "create";

          // set user ids
          vm.currentPoll.primary_user_id = vm.currentPoll.primary_user.id;
          vm.currentPoll.secondary_user_id = vm.currentPoll.secondary_user.id;
          // vm.currentPoll.category_id = vm.currentPoll.category.id;

          // then remove the user obj
          vm.currentPoll.primary_user = null;
          delete vm.currentPoll.primary_user;
          vm.currentPoll.secondary_user = null;
          delete vm.currentPoll.secondary_user;
          // and category
          vm.currentPoll.category = null;
          delete vm.currentPoll.category;
          vm.currentPoll.created_user = null;
          delete vm.currentPoll.created_user;

          // for choices we only want some bits
          vm.currentPoll.options = vm.currentPoll.options.map((opt) => ({
            id: opt.id,
            name: opt.name,
            value: opt.value,
          }));

          // users
          let userIds = [];
          if (vm.currentPoll.users) {
            userIds = vm.currentPoll.users.map((usr) => {
              if (typeof usr === "number") {
                return usr;
              }
              return usr.id;
            });
          }

          vm.currentPoll.user_ids = userIds;

          const {
            id,
            status,
            primary_user,
            secondary_user,
            self,
            user_favourite,
            favourite_count,
            created_user,
            created_time,
            modified_user,
            modified_time,
            users,
            ...payload
          } = vm.currentPoll;

          vm.$store
            .dispatch(`Polls/${action}`, payload)
            .then((resp) => {
              if (!vm.editMode) {
                vm.$router.push({
                  name: "AdminPollsEdit",
                  params: { id: resp.data.data.poll[0].id },
                });
              } else {
                vm.loadPoll(vm.$route.params.id);
              }
            })
            .catch((err) => {
              vm.loading = false;
              //error - try to display here
            });
        }
      });
    },
    async loadPoll(id) {
      let poll;

      try {
        poll = await this.$store.dispatch("Polls/load", id);
        this.loading = false;
        this.editMode = true;
      } catch (err) {
        console.log(
          "TCL:  ~ file: AddEdit.vue ~ line 187 ~ loadPoll ~ err",
          err
        );
        this.loading = false;
      }
    },
  },
  data() {
    return {
      editMode: false,
      loading: true,
      showError: false,
      selected_users: [],
    };
  },

  computed: {
    ...mapState("Polls", ["currentPoll"]),
    ...mapState({
      tags: (state) => state.tags.collection,
    }),
    ...mapGetters("SurveyCategories", ["orderedCategories"]),
    userCanAdd() {
      return this.userHasPermission("add_polls");
    },
    selectedUsers: {
      get() {
        return this.currentPoll.users;
      },
      set(val) {
        return val;
      },
    },
    compChoices() {
      return this.currentPoll.options.map((opt) => ({
        name: opt.name,
        value: opt.value,
      }));
    },
    currentCategory: {
      get() {
        if (!this.currentPoll.category) {
          return null;
        }
        const current = this.orderedCategories.filter(
          (item) => item.id === this.currentPoll.category.id
        );

        return current[0];
      },
      set(newVal, oldVal) {
        this.currentPoll.category_id = newVal.id;
        return newVal;
      },
    },
    choices: {
      get() {
        const choices = this.$store.getters["Polls/choices"];
        if (!choices || choices.length < 1) {
          return [];
        }
        return choices;
      },
      set(newVal) {
        const sorted = newVal.map((val, index) => {
          return { ...val, sortOrder: index };
        });
        this.currentPoll.options = sorted;
      },
    },
    headerTitle() {
      return this.editMode ? "Edit Poll" : "Create Poll";
    },
  },
  async mounted() {
    let resp;
    await this.$store.dispatch("SurveyCategories/list");
    await this.$store.dispatch("tags/list");
    if (!this.$route.params.id) {
      resp = await this.$store.dispatch("Polls/getBasePoll");
      this.loading = false;
    } else {
      this.loadPoll(this.$route.params.id);
    }
  },
};
</script>

<style lang="scss" scoped>
.draggable {
  li {
    align-items: center;
    display: flex;
    gap: 10px;
    justify-content: space-between;
    margin-bottom: 2rem;
    width: 100%;
  }
  &__icon {
    cursor: move;
  }

  .c-form__group {
    margin-bottom: 0;
    width: 100%;
  }
}
</style>
